(() => {
  function init(root) {
    if (root.dataset.refReady) return;
    root.dataset.refReady = 'true';
    const track = root.querySelector('[data-ref-track]');
    function move(direction) {
      if (!track) return;
      const card = track.firstElementChild;
      const step = card ? card.getBoundingClientRect().width + 20 : track.clientWidth;
      track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    root.querySelector('[data-ref-prev]')?.addEventListener('click', () => move(-1));
    root.querySelector('[data-ref-next]')?.addEventListener('click', () => move(1));
    root.querySelector('[data-ref-more]')?.addEventListener('click', event => {
      const cards = [...root.querySelectorAll('[data-ref-more-card][hidden]')];
      cards.slice(0, 6).forEach(card => { card.hidden = false; });
      if (cards.length <= 6) event.currentTarget.hidden = true;
    });
  }
  document.querySelectorAll('[data-ref-reviews]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ref-reviews]').forEach(init));
})();
